import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { ClientProfileData } from '~admin/model/client-profile-data';
import { mapClientProfileDataList } from '~admin/model/client-profile-data.mapper';
import { ClientProfileResponse } from '~client/model/client-profile-response';
import { NoArgTask, rxTask } from '~common/helper/mobx-tasks';

export type GetClientsTask = NoArgTask<ClientProfileData[]>;

/* Returns all Clients */
const performGetClients = (): Observable<ClientProfileResponse[]> =>
  apiClient.adminClientController.getClientList$();

export const getClientsTaskFactory = (): GetClientsTask =>
  rxTask<ClientProfileData[]>(() => performGetClients().pipe(map(mapClientProfileDataList)));



// WEBPACK FOOTER //
// ./interactor/client/perform-get-clients.ts